import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Block,
  Content,
  StyledImage,
  Footer,
} from './styles';

// * sectionTiles {obj} richtext obj provided by primsic
// * items {array} array of data from prismic for each card. Contains a heading {string}, image src {string}, bodyCopy {string}

function PetsSection({ sectionId, data }) {
  if (!data) return null;
  const {
    sectionTitleHtml,
    sectionSubtitleHTML,
    columnAlignment,
    items,
    titleHtml,
    buttonLink,
    buttonText,
    buttonType,
    ariaLabelButton,
    queryStringButton,
    imageBackground,
    imageBackgroundSharp,
    lang,
  } = data;
  return (
    <Wrapper
      background={
        imageBackgroundSharp
          ? imageBackgroundSharp.publicURL
          : imageBackground.url
      }
    >
      <StyledContainer id={sectionId} className="auto-margin pets-section">
        {ReactHtmlParser(sectionTitleHtml)}
        {ReactHtmlParser(sectionSubtitleHTML)}
        <Columns className="regular-columns" columns={5}>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                itemHeadingHtml,
                itemSubHeadingHtml,
                itemBodyCopyHtml,
                cta,
                ctaText,
              },
              index,
            ) => (
              <Block
                className={columnAlignment}
                key={`values-${columnAlignment}-${index.toString()}`}
              >
                {cta.url ? (
                  <Link
                    to={`${cta.url}/`}
                    className="petslink"
                    key={`Link-${cta.url}-${index.toString()}`}
                    lang={lang}
                  >
                    {imageItemSharp && (
                    <StyledImage
                      src={imageItemSharp}
                      alt={itemImage.altTag}
                    />
                    )}
                    <Content>
                      {ReactHtmlParser(itemHeadingHtml)}
                      {ReactHtmlParser(itemSubHeadingHtml)}
                      {ReactHtmlParser(itemBodyCopyHtml)}
                    </Content>
                  </Link>
                ) : (
                  <div className="petslink">
                    {imageItemSharp && (
                    <StyledImage
                      src={imageItemSharp}
                      alt={itemImage.altTag}
                    />
                    )}
                    <Content>
                      {ReactHtmlParser(itemHeadingHtml)}
                      {ReactHtmlParser(itemSubHeadingHtml)}
                      {ReactHtmlParser(itemBodyCopyHtml)}
                    </Content>
                  </div>
                )}
                {ctaText && (
                <Footer>
                  {ReactHtmlParser(titleHtml)}
                  {cta.url ? (
                    <Link
                      to={`${cta.url}/`}
                      className={`pets-cta ${buttonType}`}
                      ariaLabel={ariaLabelButton}
                      queryString={queryStringButton}
                      lang={lang}
                    >
                      {ctaText}
                    </Link>
                  ) : (
                    <div className={`pets-card-text ${buttonType}`}>
                      {ctaText}
                    </div>
                  )}
                </Footer>
                )}
              </Block>
            ),
          )}
        </Columns>
        {(titleHtml || buttonText) && (
          <Footer>
            {ReactHtmlParser(titleHtml)}
            {buttonLink && buttonText && (
              <Link
                to={`${buttonLink.url}/`}
                className={buttonType}
                ariaLabel={ariaLabelButton}
                queryString={queryStringButton}
                lang={lang}
              >
                {buttonText}
              </Link>
            )}
          </Footer>
        )}
      </StyledContainer>
    </Wrapper>
  );
}

PetsSection.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

export default PetsSection;
